import { styled } from "@mui/material";

import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import config from '../config.json';
import useAccessToken from '../hooks/use-accesstoken';
import { useTheme } from "@emotion/react";

const DocumentViewer = (props) => {
    const { accessToken } = useAccessToken();
    const theme = useTheme();

    // Update the StyledDocViewer to force full width/height.
    const StyledDocViewer = styled(DocViewer)(({ theme }) => ({
        width: "100%",
        height: "100%",
        '&, & #header-bar': {
            backgroundColor: theme.palette.background.default + ' !important',
        },
        '& #file-name, & #pdf-page-info': {
            color: theme.palette.text.primary,
        },
        '& #pdf-controls': { // disable document control bar (navigation, zoom, scroll mode etc.)
            display: 'none',
        },
        '& .react-pdf__Page__textContent.textLayer': { // disable text overlay, user may not copy text
            display: 'none',
        },
    }));

    const doc = [
        { uri: config.SERVER_URL + '/content/' + props.file },
    ];

    return (
        // Wrap in a container that forces the viewer to take all available space.
        <div style={{ width: '100%', height: '100%', display: 'flex' }}>
            <StyledDocViewer
                documents={doc}
                pluginRenderers={DocViewerRenderers}
                requestHeaders={accessToken ? { 'Authorization': 'Bearer ' + accessToken } : {}}
                config={{
                    pdfVerticalScrollByDefault: true
                }}
            />
        </div>
    );
}

export default DocumentViewer;